import React from 'react';

import { MenuItem } from '@mui/material';
import { IconMenuItem } from 'mui-nested-menu';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { CustomizedTooltip } from 'components/common';

const MENU_FONT_SIZE = '13px';
const MENU_ICON_SIZE = '17px';

const iconMenuItemStyles = {
    '& .MuiTypography-root': {
        fontSize: MENU_FONT_SIZE,
        position: 'relative',
    },
    '& .MuiBox-root': {
        alignItems: 'center',
    },
};

interface Props {
    isOwner: boolean;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

export const RenameViewMenuItem = ({ isOwner, onClick }: Props) => {
    const renameMenuItem = (
        <IconMenuItem
            sx={iconMenuItemStyles}
            leftIcon={<MuiIcon icon={'edit'} type={'outlined'} fontSize={MENU_ICON_SIZE} />}
            label={'Rename view'}
        />
    );

    if (isOwner) {
        return (
            <MenuItem onClick={onClick}>
                {renameMenuItem}
            </MenuItem>
        );
    }

    return (
        <CustomizedTooltip
            tooltipPosition={TooltipPosition.Right}
            tooltipContent={"You can't rename this view because you don't own it"}
            triggerElement={
                <MenuItem disabled={true}>
                    {renameMenuItem}
                </MenuItem>
            }
        />
    );
};
